import { render, staticRenderFns } from "./Cultivos.vue?vue&type=template&id=f3a83c5c&scoped=true&"
import script from "./Cultivos.vue?vue&type=script&lang=js&"
export * from "./Cultivos.vue?vue&type=script&lang=js&"
import style0 from "./Cultivos.vue?vue&type=style&index=0&id=f3a83c5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a83c5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
